import styled from 'styled-components'
import type { FunctionComponent } from 'react'
import { POLYGON_BUTTON_TITLE, POLYLINE_BUTTON_TITLE, REMOVE_BUTTON_TITLE } from './config'
import Measure from '../../../../../shared/assets/icons/measure.svg'
import Polygon from '../../../../../shared/assets/icons/polygon.svg'
import Trash from '../../../../../shared/assets/icons/trash.svg'
import { MapButton } from '../../../../../shared/components/SidebarMap/styles'
import Icon from '../../../../../shared/components/Icon/Icon'
import { Variant } from '../../../../../shared/components/Button/Button'
import { CurrentDrawing } from './BareDrawTool'

const StyledMapButton = styled(MapButton)<{ $inEditMode?: boolean }>`
  &:first-of-type {
    border-bottom-color: var(--greyMedium);
  }

  &:nth-of-type(2) {
    border-top-color: transparent;
    border-bottom-color: ${(props) => (props.$inEditMode ? 'var(--greyMedium)' : 'var(--blue)')};
  }

  &:last-of-type {
    border-top: var(--greyMedium);
  }
`

const DrawToolPanel = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 0;
`

export interface DrawToolControlsProps {
  onStartPolygon: () => void
  onStartPolyline: () => void
  onRemove: () => void
  inEditMode: boolean
  inDrawMode: boolean
  currentDrawing?: CurrentDrawing
}

const DrawToolControls: FunctionComponent<DrawToolControlsProps> = ({
  onStartPolygon,
  onStartPolyline,
  inEditMode,
  inDrawMode,
  onRemove,
  currentDrawing,
  ...otherProps
}) => (
  <DrawToolPanel {...otherProps}>
    <StyledMapButton
      variant={Variant.PrimaryInverted}
      onClick={onStartPolyline}
      title={POLYLINE_BUTTON_TITLE}
      size={44}
    >
      <Icon size={32}>
        <Measure />
      </Icon>
    </StyledMapButton>

    <StyledMapButton
      onClick={onStartPolygon}
      title={POLYGON_BUTTON_TITLE}
      $inEditMode={inEditMode}
      variant={Variant.PrimaryInverted}
      size={44}
    >
      <Icon size={32}>
        <Polygon />
      </Icon>
    </StyledMapButton>

    {inEditMode && (
      <StyledMapButton
        size={44}
        onClick={onRemove}
        title={REMOVE_BUTTON_TITLE}
        variant={Variant.PrimaryInverted}
      >
        <Icon size={32}>
          <Trash />
        </Icon>
      </StyledMapButton>
    )}
  </DrawToolPanel>
)

export default DrawToolControls
